/**
 * 人事履歷前端服務。
 * - 管理端（行政人員）：/api/ee/hr-resume/*
 * - 員工端（本人）    ：/api/ee/my-resume/*
 * axios 攔截器自動附加 Authorization + X-Txn-Token，服務層不手動傳 token。
 */
import axios from '../api/axios';
import {
  Certification, Education, Experience, HistoryPage, HrProfile, HrProfileUpdate,
  ProfileListItem, ResumeSection,
} from '../types/eeHrResume';

const ADMIN = '/api/ee/hr-resume';
const MINE = '/api/ee/my-resume';

type DetailRow = Education | Experience | Certification;

// ── 管理端 ──────────────────────────────────────────────

export const listProfiles = async (params?: {
  search?: string; active?: boolean;
}): Promise<ProfileListItem[]> => (await axios.get(`${ADMIN}/profiles`, { params })).data;

export const getProfile = async (userId: number): Promise<HrProfile> =>
  (await axios.get(`${ADMIN}/profiles/${userId}`)).data;

export const upsertProfile = async (userId: number, body: HrProfileUpdate): Promise<HrProfile> =>
  (await axios.put(`${ADMIN}/profiles/${userId}`, body)).data;

export const revealId = async (userId: number): Promise<{ user_id: number; id_number: string }> =>
  (await axios.post(`${ADMIN}/profiles/${userId}/reveal-id`)).data;

export const getHistory = async (
  userId: number, params?: { offset?: number; limit?: number },
): Promise<HistoryPage> => (await axios.get(`${ADMIN}/profiles/${userId}/history`, { params })).data;

export const createDetail = async (
  userId: number, section: ResumeSection, data: Partial<DetailRow>,
): Promise<DetailRow> => (await axios.post(`${ADMIN}/profiles/${userId}/${section}`, data)).data;

export const updateDetail = async (
  userId: number, section: ResumeSection, detailId: number, data: Partial<DetailRow>,
): Promise<DetailRow> =>
  (await axios.put(`${ADMIN}/profiles/${userId}/${section}/${detailId}`, data)).data;

export const deleteDetail = async (
  userId: number, section: ResumeSection, detailId: number,
): Promise<void> => { await axios.delete(`${ADMIN}/profiles/${userId}/${section}/${detailId}`); };

// ── 員工端（本人）──────────────────────────────────────

export const getMyResume = async (): Promise<HrProfile> => (await axios.get(`${MINE}/`)).data;

export const revealMyId = async (): Promise<{ user_id: number; id_number: string }> =>
  (await axios.post(`${MINE}/reveal-id`)).data;

export const updateMyResume = async (body: HrProfileUpdate): Promise<HrProfile> =>
  (await axios.put(`${MINE}/`, body)).data;

export const getMyHistory = async (
  params?: { offset?: number; limit?: number },
): Promise<HistoryPage> => (await axios.get(`${MINE}/history`, { params })).data;

export const createMyDetail = async (
  section: ResumeSection, data: Partial<DetailRow>,
): Promise<DetailRow> => (await axios.post(`${MINE}/${section}`, data)).data;

export const updateMyDetail = async (
  section: ResumeSection, detailId: number, data: Partial<DetailRow>,
): Promise<DetailRow> => (await axios.put(`${MINE}/${section}/${detailId}`, data)).data;

export const deleteMyDetail = async (
  section: ResumeSection, detailId: number,
): Promise<void> => { await axios.delete(`${MINE}/${section}/${detailId}`); };
